import { render, staticRenderFns } from "./NoticeListBody.vue?vue&type=template&id=861d6e5c&scoped=true&"
import script from "./NoticeListBody.vue?vue&type=script&lang=js&"
export * from "./NoticeListBody.vue?vue&type=script&lang=js&"
import style0 from "./NoticeListBody.vue?vue&type=style&index=0&id=861d6e5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861d6e5c",
  null
  
)

export default component.exports